import * as React from "react";
import { Search, X } from "lucide-react";
import { Input } from "./input";

/** Estilo oficial dos campos de pesquisa em tabelas (referência: Produtos / Insumos). */
export const TABLE_SEARCH_INPUT_CLASS =
  "h-10 w-full rounded-md border border-gray-200 bg-white pl-9 shadow-sm";

interface TableSearchInputProps {
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  autoComplete?: string;
}

export function TableSearchInput({
  value,
  onValueChange,
  placeholder = "Pesquisar",
  className = "",
  id,
  autoComplete = "off",
}: TableSearchInputProps) {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const showClear = value.length > 0;

  const handleClear = () => {
    onValueChange("");
    inputRef.current?.focus();
  };

  return (
    <div className={`relative w-full ${className}`.trim()}>
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        placeholder={placeholder}
        className={`${TABLE_SEARCH_INPUT_CLASS}${showClear ? " pr-9" : ""}`}
        autoComplete={autoComplete}
        id={id}
      />
      {showClear ? (
        <button
          type="button"
          onClick={handleClear}
          className="absolute right-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-[#000] hover:opacity-70"
          aria-label="Limpar pesquisa"
          tabIndex={-1}
        >
          <X className="h-4 w-4" strokeWidth={2} />
        </button>
      ) : null}
    </div>
  );
}
